var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 2A1.5 1.5 0 0 0 5 3.5v17A1.5 1.5 0 0 0 6.5 22h13a1.5 1.5 0 0 0 1.5-1.5V5.908q-.001-.21-.056-.408H19.5A2.5 2.5 0 0 1 17 3v-.979A1.5 1.5 0 0 0 16.748 2zm11.5.602L20.17 4.5h-.67A1.5 1.5 0 0 1 18 3zM4 3.5A2.5 2.5 0 0 1 6.5 1h10.249a2.5 2.5 0 0 1 1.646.619l2.751 2.407A2.5 2.5 0 0 1 22 5.908V20.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 4 20.5zm9 2a.5.5 0 0 0-1 0v9.793l-2.646-2.647a.5.5 0 0 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L13 15.293zm-4 14a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
});
const SvgDownload = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMkM1LjY3MTU3IDIgNSAyLjY3MTU3IDUgMy41VjIwLjVDNSAyMS4zMjg0IDUuNjcxNTcgMjIgNi41IDIySDE5LjVDMjAuMzI4NCAyMiAyMSAyMS4zMjg0IDIxIDIwLjVWNS45MDc1NEMyMSA1Ljc2ODM0IDIwLjk4MDcgNS42MzEzMiAyMC45NDM2IDUuNUgxOS41QzE4LjExOTMgNS41IDE3IDQuMzgwNzEgMTcgM1YyLjAyMTIzQzE2LjkxNzQgMi4wMDcxOCAxNi44MzMzIDIgMTYuNzQ4NSAySDYuNVpNMTggMi42MDE4OEwyMC4xNjkzIDQuNUgxOS41QzE4LjY3MTYgNC41IDE4IDMuODI4NDMgMTggM1YyLjYwMTg4Wk00IDMuNUM0IDIuMTE5MjkgNS4xMTkyOSAxIDYuNSAxSDE2Ljc0ODVDMTcuMzU0MSAxIDE3LjkzOTEgMS4yMTk3OSAxOC4zOTQ4IDEuNjE4NTZMMjEuMTQ2MyA0LjAyNjA5QzIxLjY4ODggNC41MDA4MSAyMiA1LjE4NjYzIDIyIDUuOTA3NTRWMjAuNUMyMiAyMS44ODA3IDIwLjg4MDcgMjMgMTkuNSAyM0g2LjVDNS4xMTkyOSAyMyA0IDIxLjg4MDcgNCAyMC41VjMuNVpNMTMgNS41QzEzIDUuMjIzODYgMTIuNzc2MSA1IDEyLjUgNUMxMi4yMjM5IDUgMTIgNS4yMjM4NiAxMiA1LjVWMTUuMjkyOUw5LjM1MzU1IDEyLjY0NjRDOS4xNTgyOSAxMi40NTEyIDguODQxNzEgMTIuNDUxMiA4LjY0NjQ1IDEyLjY0NjRDOC40NTExOCAxMi44NDE3IDguNDUxMTggMTMuMTU4MyA4LjY0NjQ1IDEzLjM1MzZMMTIuMTQ2NCAxNi44NTM2QzEyLjI0MDIgMTYuOTQ3MyAxMi4zNjc0IDE3IDEyLjUgMTdDMTIuNjMyNiAxNyAxMi43NTk4IDE2Ljk0NzMgMTIuODUzNiAxNi44NTM2TDE2LjM1MzYgMTMuMzUzNkMxNi41NDg4IDEzLjE1ODMgMTYuNTQ4OCAxMi44NDE3IDE2LjM1MzYgMTIuNjQ2NEMxNi4xNTgzIDEyLjQ1MTIgMTUuODQxNyAxMi40NTEyIDE1LjY0NjQgMTIuNjQ2NEwxMyAxNS4yOTI5VjUuNVpNOSAxOS41QzkgMTkuMjIzOSA5LjIyMzg2IDE5IDkuNSAxOUgxNS41QzE1Ljc3NjEgMTkgMTYgMTkuMjIzOSAxNiAxOS41QzE2IDE5Ljc3NjEgMTUuNzc2MSAyMCAxNS41IDIwSDkuNUM5LjIyMzg2IDIwIDkgMTkuNzc2MSA5IDE5LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";